













import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContentRetriever } from '../Scripts/ContentRetriever';

@Component
export default class RemoteHelp extends Vue {
	@Prop() public topic!: string;

	loading = true;
	error = '';
	content = '';

	public async mounted (): Promise<void> {
		try {
			this.content = await ContentRetriever.getContent(this.topic);
		} catch (error) {
			this.error = error;
		} finally {
			this.loading = false;
		}
	}
}
